import React, { useState } from "react";
import Headerdash from "../pages/head"; // Import Header Component
import Sidebar from "../pages/sidebar";

export default function AccountPage() {
  const [profilePic, setProfilePic] = useState(null);
  const [firstName, setFirstName] = useState("Bryan");
  const [lastName, setLastName] = useState("Cranston");
  const [email, setEmail] = useState("bryan.cranston@mail.com");
  const [address, setAddress] = useState("123 Hollywood Blvd, Los Angeles, CA");
  const [pinCode, setPinCode] = useState("");
  const [country, setCountry] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [currentPlan, setCurrentPlan] = useState("Basic Plan");

  const handleProfilePicChange = (e) => {
    setProfilePic(URL.createObjectURL(e.target.files[0]));
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      {/* Header */}
      <Headerdash />

      {/* Main content wrapper */}
      <div className="flex flex-1">
        {/* Sidebar */}
        <div className="w-64 bg-white shadow-lg">
          <Sidebar />
        </div>

        {/* Account Form Content */}
        <div className="flex-1 ml-4 mt-4 p-8 overflow-y-auto">
          <div className="bg-white rounded-lg shadow-xl p-8">
            <form>
              {/* Profile Picture */}
              <div className="flex items-center space-x-6 mb-8">
                <div className="relative">
                  <img
                    src={
                      profilePic ||
                      "https://via.placeholder.com/150/000000/FFFFFF/?text=Profile"
                    }
                    alt="Profile"
                    className="w-24 h-24 rounded-full border border-gray-300 object-cover shadow-md"
                  />
                  <label
                    htmlFor="upload-picture"
                    className="absolute bottom-0 right-0 bg-blue-500 text-white p-2 rounded-full cursor-pointer hover:bg-blue-600"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M15.232 5.232l3.536 3.536m1.768-4.304a2.5 2.5 0 113.536 3.536L10.5 21H5.5v-5.5l11.036-11.036z"
                      />
                    </svg>
                  </label>
                  <input
                    type="file"
                    onChange={handleProfilePicChange}
                    id="upload-picture"
                    className="hidden"
                  />
                </div>
                <div>
                  <p className="text-lg font-semibold text-gray-700">
                    Update Profile Picture
                  </p>
                  <p className="text-sm text-gray-500">
                    Upload a square photo for best results.
                  </p>
                </div>
              </div>

              {/* Name Fields */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-gray-700 mb-1">First Name</label>
                  <input
                    type="text"
                    className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  />
                </div>
                <div>
                  <label className="block text-gray-700 mb-1">Last Name</label>
                  <input
                    type="text"
                    className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  />
                </div>
              </div>

              {/* Email Field */}
              <div className="mb-6">
                <label className="block text-gray-700 mb-1">Email</label>
                <input
                  type="email"
                  className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>

              {/* Password Section */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-gray-700 mb-1">Current Password</label>
                  <input
                    type="password"
                    className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="••••••••"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                  />
                  <a
                    href="/forgot-password"
                    className="text-blue-500 text-sm mt-1 inline-block hover:underline"
                  >
                    Forgot Password?
                  </a>
                </div>
                <div>
                  <label className="block text-gray-700 mb-1">New Password</label>
                  <input
                    type="password"
                    className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="••••••••"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </div>
              </div>

              {/* Address Field */}
              <div className="mb-6">
                <label className="block text-gray-700 mb-1">Address</label>
                <input
                  type="text"
                  className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  placeholder="Enter your address"
                />
              </div>

              {/* Pin Code and Country Fields */}
              <div className="mb-6 flex space-x-6">
                {/* Pin Code */}
                <div className="flex-1">
                  <label className="block text-gray-700 mb-1">Pin Code</label>
                  <input
                    type="text"
                    className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={pinCode}
                    onChange={(e) => setPinCode(e.target.value)}
                    placeholder="Enter your pin code"
                  />
                </div>

                {/* Country */}
                <div className="flex-1">
                  <label className="block text-gray-700 mb-1">Country</label>
                  <input
                    type="text"
                    className="w-full p-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={country}
                    onChange={(e) => setCountry(e.target.value)}
                    placeholder="Enter your country"
                  />
                </div>
              </div>

              {/* Current Plan Section */}
              <div className="mb-6">
                <label className="block text-gray-700 mb-1">Current Plan</label>
                <div className="flex items-center justify-between border rounded-lg p-3 bg-gray-100">
                  <span className="text-lg text-gray-700">{currentPlan}</span>
                  <button
                    type="button"
                    className="text-blue-500 text-sm hover:underline"
                    onClick={() => alert("Change Plan functionality")}
                  >
                    Change Plan
                  </button>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex justify-between items-center">
                <button
                  type="button"
                  className="px-6 py-2 bg-red-500 text-white rounded-lg shadow hover:bg-red-600 focus:ring-2 focus:ring-red-500"
                >
                  Delete Account
                </button>
                <div className="flex space-x-4">
                  <button
                    type="button"
                    className="px-6 py-2 bg-gray-200 rounded-lg shadow hover:bg-gray-300"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="px-6 py-2 bg-blue-500 text-white rounded-lg shadow hover:bg-blue-600 focus:ring-2 focus:ring-blue-500"
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
